<template>
    <div :id="_comId" :class="`${__class} ${styleClass} col-${col} ${getReadonly?'readonly':''} ${getDisabled?'disabled':''}`" v-show="__show" :style="{padding:padding}">
        <div :class="`label-wrap`" v-if="!!label" :style="`width: ${getLabelwidth}`" v-tooltip="{classes:['info'], content: tip,trigger:'hover'}">
            <label><span>{{label}}</span><b v-if="getRequired">*</b></label>
        </div>

        <div :class="`input-wrap ${focus} ${(errors.has(name)||errors.has(`${name}_hasHidden`))?'is-danger':'' }`"
             :style="{width:`calc(100% - ${!!label?getLabelwidth:'0px'})`}"
             v-tooltip="{classes:['is-danger'], content: errors.first(name), show:errors.has(name),trigger:'hover'}">
            <div class="checkbox-item" :key="index" v-for="(item,index) in getList">
                <label :for="`${_comId}_${index}`" class="radio" @click="doClick(item)">
                    <span class="radio-bg"></span>
                    <input type="checkbox"
                           :disabled="getDisabled"
                           :readonly="getReadonly"
                           :name="`${name}_hasHidden`"
                           :id="`${_comId}_${index}`"
                           v-model="getValue"
                           :value="item.value"
                           v-validate="{required:getRequired}"
                           :data-submit="getSubmit"
                           :data-vv-as="label"/>
                    <span class="radio-on"></span>
                    <span>{{item.label}}</span>
                </label>
            </div>
            <input type="hidden" :name="name" :value="realValue">
        </div>

    </div>
</template>

<script>
/**
     * 多选组件
     * @module jgp-checkbox
     * @example <jgp-checkbox _label="多选框" _name="checkbox"
     _value="['china','usa']"
     _list="[{'value':'china','label':'中国'},{'value':'usa',
            'label':'美国'},{'value':'un','label':'英国'}]">
     </jgp-checkbox>
     * @desc 加载数据源三种方式：1、异步 _url与_ajax_param(可选)，2、页面里配置 _list 3、 _active_key
     */
import Common from '../../utils/common'
import Check from 'check-types'

// TODO xxxxx替换成store所属模块
export default {
    data() {
        return {
            styleClass: 'inline-control',
            focus: '',
            activeUrl: '/sys/config-drop'
        }
    },
    /**
         * @prop {String} _url 异步请求下拉数据列表
         * @prop {String} _ajax_param 异步请求参数
         * @prop {String} _list 下拉列表 [{'value':'cccc','label':'2222'}]
         * @prop {String} _active_key 绑定下拉源，后台维护的功能组标识
         * @prop {String} _value 多选框可能是多个默认值,多个值以逗号分隔
         * @prop {String} _name
         * @prop {String} _label 标题
         * @prop {String} _label_width 标题宽度
         * @prop {String} _placeholder 提示信息
         * @prop {String} _tip 长文本提示 在LABEL hover的时候显示
         * @prop {String} _col 所占列宽
         * @prop {String} _required 是否可用 {默认:false}
         * @prop {String} _readonly 是否只读 {默认:false}
         * @prop {String} _disabled 是否禁用 {默认:false}
         * @prop {String} _padding 内边距 {默认(只负责 上、左、右):'5px 5px 0 5px'}
         * @prop {String} _onchange change事件
         * @prop {String} _onclick click事件
         */
    props: {
        '_url': String,
        '_server': {
            type: String
        },
        '_ajax_param': {
            type: Object,
            default() {
                return {}
            }
        },
        '_value': String,
        '_label': String,
        '_label_width': {
            type: String,
            default: '80px'
        },
        '_name': String,
        '_col': {
            type: String | Number,
            default: '6'
        },
        '_required': {
            type: String | Boolean,
            default: 'false'
        },
        '_placeholder': String,
        '_tip': String,
        '_readonly': {
            type: String,
            default: 'false'
        },
        '_disabled': {
            type: String,
            default: 'false'
        },
        '_list': {
            type: String | Object,
            default: '[]'
        },
        '_active_key': String,
        '_padding': {
            type: String,
            default: '5px 5px 0'
        },
        '_onchange': String,
        '_submit': {
            type: String | Boolean,
            default: 'true'
        }
    },
    watch: {
        value(value) {
            this.$nextTick(() => {
                if (value && value.length > 0) {
                    this.errors.clear();
                }
                if (this.form && this.form.setKeyValue) this.form.setKeyValue(this.name, value);
                if (this.form && this.form.changeErrors) this.form.changeErrors(this.name, this.errors);
                if (this.onchange) Common.doFn(this.onchange, value);
                this.$emit('change', value);
            })
        },
        active_key() {
            this.load();
        }
    },
    computed: {
        getLabelwidth() {
            let formGroup = this.formGroup;
            let form = this.form;
            let parentLabelWidth = formGroup && formGroup.label_width ? formGroup.label_width : form && form.label_width ? form.label_width : undefined;
            return parentLabelWidth || this.label_width;
        },
        getList() {
            return Common.toJson(this.list);
        },
        getRequired() {
            return Common.toBool(this.required)
        },
        getReadonly() {
            return (this.form && this.form.getReadonly) || Common.toBool(this.readonly)
        },
        getDisabled() {
            return (this.form && this.form.getDisabled) || Common.toBool(this.disabled)
        },
        getValue: {
            get() {
                let defaultValues;
                let value = this.value;
                if (!value) value = [];

                if (Check.string(value) && Common.trim(value) !== '') {
                    if (value.includes(',')) {
                        defaultValues = value.split(',');
                    } else {
                        defaultValues = Common.toJson(value);
                    }
                } else {
                    defaultValues = value;
                }
                if (!Check.array(defaultValues)) {
                    defaultValues = [defaultValues]
                }
                // defaultValues = defaultValues.map(item => /^['\'','"'][0-9]+['\'','"']$/.test(item) ? item : Number(item))
                return defaultValues;// defaultValues.map(item => /^['\'','"'][0-9]+['\'','"']$/.test(item) ? item : Number(item));
            },
            set(value) {
                this.value = this.getRealValue(value);
            }
        },
        realValue() {
            return this.getRealValue()
        },
        form() {
            return this.getForm(this);
        },
        formGroup() {
            return this.getFormGroup(this);
        },
        getSubmit() {
            return Common.toBool(this.submit) ? 'yes' : 'no'
        },
        getActiveUrl() {
            return this.server + this.activeUrl;
        }
    },
    methods: {
        getRealValue(value) {
            let vs = [];
            if (value) {
                vs = value;
            } else if (this.getValue) {
                vs = this.getValue;
            }
            let result = [];
            if (!vs) return '';
            for (let item of vs) {
                if (Common.checkInputValue(item) && item !== '') {
                    result.push(item);
                }
            }
            if (result.length === 0) {
                return '';
            } else {
                return result.sort().join(',');
            }
        },
        getForm(com) {
            if (this.parentLevel > 10) {
                return undefined
            }
            let parent = com.$parent;
            if (!parent) return undefined;
            if (parent.cType === 'jgp-form' || parent.cType === 'jgp-query') {
                return parent;
            } else {
                this.parentLevel += 1;
                return this.getForm(parent)
            }
        },
        getFormGroup(com) {
            let parent = com.$parent;
            if (!parent) return undefined;
            if (this.parentLevel > 10 || parent.cType === 'jgp-form' || parent.cType === 'jgp-query') {
                return undefined
            }
            if (parent.cType === 'jgp-form-group') {
                return parent;
            } else {
                this.parentLevel += 1;
                return this.getFormGroup(parent)
            }
        },
        load() {
            this.$nextTick(() => {
                if (this.url && !this.active_key) {
                    Common.post(this.url, this.ajax_param, (result) => {
                        if (result.flag) {
                            this.$set(this, 'list', result.data.ldata);
                            // this.initValue();
                        }
                    });
                } else if (this.url && this.active_key) {
                    Common.post(this.url, { activeKey: this.active_key }, (result) => {
                        if (result.flag) {
                            this.$set(this, 'list', result.data.ldata);
                            // this.initValue();
                        }
                    });
                } else if (this.active_key && typeof this.form === 'undefined') {
                    Common.post(this.getActiveUrl, { activeKey: this.active_key }, (result) => {
                        if (result.flag) {
                            this.$set(this, 'list', result.data.ldata);
                            // this.initValue();
                        }
                    });
                }
            })
        },
        doClick(item) {
            if (this.onclick) Common.doFn(this.onclick, item)
        },
        listValues() {
            return this.getList.map(item => /^['\'','"'][0-9]+['\'','"']$/.test(item.value) ? item : Number(item.value));
        },
        /**
             * @name val
             * @function
             * @param value {String}
             * @desc  获取值 JGP.checkbox('id').val()。设置值 JGP.checkbox('id').val(['1','2'])
             */
        val(value, submit) {
            const _this = this;
            if (value) {
                _this.$set(_this, 'value', value);
            } else {
                return _this.getValue;
            }
            if (typeof submit !== 'undefined') {
                _this.$set(_this, 'submit', submit);
            }
        },
        /**
             * @name reset
             * @function
             * @desc 清空已输入的内容
             */
        reset() {
            this.value = undefined;
        },
        valid() {
            return this.$validator.validate();
        }
    },
    /*
         在实例初始化之后，数据观测 (data observer)
         和 event/watcher 事件配置之前被调用。
         */
    beforeCreate() {
    },
    /*
         在实例创建完成后被立即调用。在这一步，实例已完成以下
         的配置：数据观测 (data observer)，属性和方法的运算，
         watch/event 事件回调。然而，挂载阶段还没开始，
         $ el 属性目前不可见。
         */
    created() {
        if (this.form) { this.form.els.push({ name: this.name, el: this }); }
        this.load();
    },
    /*
         在挂载开始之前被调用：相关的 render 函数首次被调用。
         */
    beforeMount() {
        // this.initValue()
    },
    /*
         el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
         如果 root 实例挂载了一个文档内元素，当 mounted 被调用时
         vm.$ el 也在文档内。

         注意 mounted 不会承诺所有的子组件也都一起被挂载。如果你希望
         等到整个视图都渲染完毕，可以用 vm.$ nextTick 替换掉 mounted：
         */
    mounted() {
    },
    /*
         数据更新时调用，发生在虚拟 DOM 打补丁之前。这里适合在更新之前访问现有的 DOM，
         比如手动移除已添加的事件监听器。
         */
    beforeUpdate() {
    },
    /*
         由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。

         当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
         然而在大多数情况下，你应该避免在此期间更改状态。如果要相应状态改变，通常最好使
         用计算属性或 watcher 取而代之。

         注意 updated 不会承诺所有的子组件也都一起被重绘。如果你希望等到整个视图都重
         绘完毕，可以用 vm.$ nextTick 替换掉 updated：
         */
    updated() {
    },
    /* keep-alive 组件激活时调用。 */
    activated() {
    },
    /* keep-alive 组件停用时调用。 */
    deactivated() {
    },
    /* 实例销毁之前调用。在这一步，实例仍然完全可用。 */
    beforeDestroy() {
        if (this.form) {
            this.form.removeEl(this.name);
        }
    },
    /* Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁。 */
    destroyed() {
    }
}
</script>
